module.exports = __webpack_public_path__ + "img/document-text.96301bda.svg";